import { createContext, ReactNode, useContext, useState } from 'react';
import { InvoiceTab } from 'root/pathnames';
import { InvoicesParams } from 'types/invoices';
import {
  DEFAULT_PARAMS_OWN,
  DEFAULT_PARAMS_FOREIGN,
  DEFAULT_PARAMS_ADMINISTRATIVE,
  DEFAULT_PARAMS_INTERNAL,
} from './invoicesContext.const';

export const useProvideInvoicesContext = () => {
  const [paramsOwn, setParamsOwn] =
    useState<InvoicesParams>(DEFAULT_PARAMS_OWN);
  const [paramsForeign, setParamsForeign] = useState<InvoicesParams>(
    DEFAULT_PARAMS_FOREIGN,
  );
  const [paramsAdministrative, setParamsAdministrative] =
    useState<InvoicesParams>(DEFAULT_PARAMS_ADMINISTRATIVE);
  const [paramsInternal, setParamsInternal] = useState<InvoicesParams>(
    DEFAULT_PARAMS_INTERNAL,
  );

  const getTabParams = (invoiceTab: InvoiceTab) => {
    switch (invoiceTab) {
      case InvoiceTab.OWN:
        return paramsOwn;
      case InvoiceTab.FOREIGN:
        return paramsForeign;
      case InvoiceTab.ADMINISTRATIVE:
        return paramsAdministrative;
      case InvoiceTab.INTERNAL:
        return paramsInternal;
      // no default
    }
  };

  const getSetTabParams = (invoiceTab: InvoiceTab) => {
    switch (invoiceTab) {
      case InvoiceTab.OWN:
        return setParamsOwn;
      case InvoiceTab.FOREIGN:
        return setParamsForeign;
      case InvoiceTab.ADMINISTRATIVE:
        return setParamsAdministrative;
      case InvoiceTab.INTERNAL:
        return setParamsInternal;
      // no default
    }
  };

  return {
    getTabParams,
    getSetTabParams,
  };
};

const invoicesContext = createContext<
  ReturnType<typeof useProvideInvoicesContext> | undefined
>(undefined);

export const useInvoicesContext = () => {
  const context = useContext(invoicesContext);

  if (context === undefined) {
    throw new Error(
      'useInvoicesContext must be used within a InvoicesProvider',
    );
  }

  return context;
};

export const InvoicesContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const auth = useProvideInvoicesContext();
  return (
    <invoicesContext.Provider value={auth}>{children}</invoicesContext.Provider>
  );
};
